import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const promoteScenarioToDraftRegime = api(async function promoteScenarioToDraftRegime({
    scenarioId,
    variantId,
    newName,
    mode,
}) {
    return mutate(
        gql`
            mutation PromoteScenarioToDraftRegime(
                $scenarioId: String!
                $variantId: String
                $newName: String
                $mode: String
            ) {
                promoteScenarioToDraftRegime(
                    scenarioId: $scenarioId
                    variantId: $variantId
                    newName: $newName
                    mode: $mode
                ) {
                    regimeId
                    regimeName
                    sourceState
                    status
                }
            }
        `,
        { scenarioId, variantId, newName, mode },
        { returns: "promoteScenarioToDraftRegime" }
    )
})
